/** Panel de empresas del Super Admin (`/empresas`, T045). */
import { createFileRoute } from '@tanstack/react-router';

import { CompaniesPage } from '../../features/companies/companies-page';

export const Route = createFileRoute('/_app/empresas')({
  component: CompaniesPage,
});
